import * as THREE from 'three';
import { mapValue } from '../../../Utils/UtilityFunctions.js';
import { GeoObject } from '@data/geodata/legacy/GeoObject.js';
import { getColorScheme, getGlobalState } from '@gui/store/persistent/persistentStore.js';
import { getGrid } from 'store/LoadingStore';
import { createThickLine } from '../../../Graphics/ShapeBuilder';
import { GroundRoadTextures } from '@data/geodata/legacy/GroundRoadTextures.js';

type Road = {
    points: THREE.Vector3[];
    emission: number;
};
export class Roads extends GeoObject {
    roads: Road[] = [];
    minEmissionValue = Infinity;
    maxEmissionValue = -Infinity;

    hue = getColorScheme().ROADS_H;
    s = getColorScheme().ROADS_S;
    lRange = getColorScheme().ROADS_L;

    constructor() {
        super();
        this.name = 'Roads';
    }

    isVisible() {
        return getGlobalState().context.showRoads;
    }

    override toggleVisibility() {
        super.toggleVisibility();
        getGrid().getActiveGeodata().dataObjectLegacy.Ground?.updateTerrainlineShader();
    }

    override updateColors() {}

    override initMeshes(): { trianglesMesh: THREE.Group; strokesMesh: THREE.Group } {
        this.trianglesMesh = new THREE.Group();
        this.strokesMesh = new THREE.Group();
        for (let road of this.roads) {
            const vertices = [];
            const colors = [];

            const { points, emission } = road;
            const color = new THREE.Color();

            for (let point of points) {
                vertices.push(point.x, point.y, point.z);
                const l = mapValue(emission, this.minEmissionValue, this.maxEmissionValue, this.lRange[0], this.lRange[1]);
                color.setHSL(this.hue, this.s, l);
                colors.push(color.r, color.g, color.b);
            }

            // const pointsShape = create3DPointsShape(vertices, 0.3);
            const roadShape = createThickLine(vertices, colors, 5);
            this.strokesMesh.attach(roadShape);

            const ground = getGrid().getActiveGeodata().dataObjectLegacy.Ground;
            ground?.addTerrainLines(roadShape, GroundRoadTextures.ROAD_HALF_WIDTH);
            ground?.updateTerrainlineShader();
        }
        this.strokesMesh.name = 'Roads';
        this.trianglesMesh.name = 'Roads';
        return { trianglesMesh: this.trianglesMesh, strokesMesh: this.strokesMesh };
    }
}
